import {} from 'lodash-es';

const styles = theme => ({
  leasecardItem: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    padding: '12px 16px',
    margin: '0 0 43px',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '14px',
    '& p': {
      fontSize: '14px',
      color: '#342D3D',
      '&:first-child': {
        color: '#565960',
      },
    },
  },
  badge: {
    position: 'absolute',
    background: '#1C999B',
    top: -18,
    left: 18,
    color: theme.palette.primary.contrastText,
    fontWeight: '400',
    fontSize: '12px',
    padding: '2px 15px',
    minWidth: '72px',
    maxWidth: '150px',
    textAlign: 'center',
  },
  contentContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  userImg: {
    display: 'flex',
  },
  detailsHolder: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    flexGrow: '1',
    '& div:first-child': {
      '& p': {
        color: '#342D3D',
      },
    },
  },
  link: {
    textDecoration: 'none',
  },
  '@media (min-width: 768px)': {
    detailsHolder: {
      gridTemplateColumns: '25% 25% 15% 15% 20%',
    },
  },
  '@media (min-width: 992px)': {
    leasecardItem: {
      flexWrap: 'nowrap',
    },
    contentContainer: {
      flexWrap: 'nowrap',
    },
  },
});

export default styles;
